module.exports = __webpack_public_path__ + "static/media/bfile-golf_cart.c11ba8ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-golf_cart.svg
// module id = 206
// module chunks = 0